import React from 'react';
import { Select } from 'antd';

const LANGUAGES = [
  { code: 'en', label: 'English', flag: '🇬🇧' },
  { code: 'es', label: 'Español', flag: '🇪🇸' },
  { code: 'pt', label: 'Português', flag: '🇧🇷' },
];

interface LanguageSelectorProps {
  value?: string;
  onChange?: (value: string) => void;
  disabled?: boolean;
}

const LanguageSelector: React.FC<LanguageSelectorProps> = ({ value, onChange, disabled }) => (
  <Select
    value={value}
    onChange={onChange}
    disabled={disabled}
    placeholder="Select language"
    style={{ width: '100%' }}
    options={LANGUAGES.map(lang => ({
      value: lang.code,
      label: (
        <span>
          <span style={{ fontSize: 18, marginRight: 6 }}>{lang.flag}</span>
          {lang.label}
        </span>
      ),
    }))}
  />
);

export default LanguageSelector; 